import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { TextField } from "@mui/material";
import { uk } from "date-fns/locale";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";

import ToothTable from "../ToothTable/ToothTable";
import { RootState } from "@/store/store";
import { setIsVisibleDentalFormulaModal } from "@/store/ui/ui";
import { resetSelectedFormulaData } from "@/store/patients/patients";
import CloseCross from "@/shared/components/CloseCross/CloseCross";
import Title from "@/shared/components/Title/Title";

import { modalStyles, inputStyles } from "@/utils/constants";

import "./ToothFormulaScreen.scss";

export default function ToothFormulaScreen() {
    const [notes, setnotes] = useState<string>("");
    const newDate = new Date();
    const dispatch = useDispatch();
    const isVisibleModalFormula = useSelector(
        (state: RootState) => state.ui.isVisibleDentalFormulaModal,
    );
    const selectedFormulaData = useSelector(
        (state: RootState) => state.patients.selectedDentalFormula,
    );
    const isSelectedDefnalFormula = useSelector(
        (state: RootState) => state.patients.isSelectedDefnalFormula,
    );

    function closeToothScreen() {
        dispatch(setIsVisibleDentalFormulaModal(false));
        dispatch(resetSelectedFormulaData());
    }

    return (
        <Modal
            open={isVisibleModalFormula}
            onClose={closeToothScreen}
            aria-labelledby='modal-modal-title'
            aria-describedby='modal-modal-description'
        >
            <Box sx={modalStyles}>
                <div className='drawer_title_container'>
                    <Title
                        tag='h3'
                        text={
                            isSelectedDefnalFormula
                                ? `Зубна формува від ${format(
                                      selectedFormulaData[0]?.date,
                                      " d MMMM yyyy",
                                      {
                                          locale: uk,
                                      },
                                  ).replace(/^./, char =>
                                      char.toLocaleUpperCase(),
                                  )} року`
                                : `Додати зубну формулу від ${format(
                                      newDate,
                                      " d MMMM yyyy",
                                      {
                                          locale: uk,
                                      },
                                  ).replace(/^./, char =>
                                      char.toLocaleUpperCase(),
                                  )} року`
                        }
                    />
                    <CloseCross onClick={closeToothScreen} />
                </div>
                {isSelectedDefnalFormula ? (
                    <div className='drawer_subtitle_container'>
                        {" "}
                        <Title
                            tag='h4'
                            text={`Лікар: ${selectedFormulaData[0]?.doctorId?.name}`}
                        />
                        <Title
                            tag='h4'
                            text={`Примітки: ${
                                selectedFormulaData[0]?.notes.length > 0
                                    ? selectedFormulaData[0]?.notes
                                    : "примітки відсутні"
                            }`}
                        />
                    </div>
                ) : (
                    <TextField
                        type='email'
                        id='outlined-error-helper-text'
                        label='Примітки'
                        variant='outlined'
                        onChange={e => setnotes(e.target.value)}
                        inputProps={{ maxLength: 160 }}
                        sx={{
                            ...inputStyles.root,
                            marginBottom: 2,
                            width: "100%",
                            marginTop: "20px",
                        }}
                    />
                )}

                <ToothTable notes={notes} />
            </Box>
        </Modal>
    );
}
